import { Disc, Monitor } from "lucide-react";
import { useEffect, useRef } from "react";
// import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar";

interface ParticipantDisplayProps {
  participantName: string;
  avatarSrc?: string;
  isRecording: boolean;
  isScreenSharing: boolean;
  stream: MediaStream | null;
  isActiveSpeaker: boolean;
  isLocalUser: boolean;
}

// Component responsible for displaying the video, avatar, and recording status.
const ParticipantDisplay: React.FC<ParticipantDisplayProps> = ({
  participantName,
  avatarSrc,
  isRecording,
  isScreenSharing,
  stream,
  isActiveSpeaker,
  isLocalUser,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play().catch((error) => {
        console.warn(
          "Video play failed (user interaction might be needed):",
          error,
        );
      });
    }
  }, [stream, stream?.id]);
  useEffect(() => {
    if (!videoRef.current || !stream) return;

    if (videoRef.current.srcObject !== stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream?.id]);
  const showVideo =
    stream &&
    stream.getVideoTracks().length > 0 &&
    stream.getVideoTracks()[0].enabled;
  const showActiveSpeakerBorder = isActiveSpeaker;

  return (
    <div
      className={`relative lg:h-full flex-grow bg-gray-700 rounded-xl overflow-hidden shadow-lg lg:aspect-video
      ${showActiveSpeakerBorder ? "border-4 border-[#13a8e1]" : ""}`}
    >
      {showVideo ? (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted={isLocalUser || participantName === "Your Screen"}
          className={`absolute inset-0 w-full h-full ${
            isScreenSharing ? "object-contain" : "object-cover"
          }`}
        />
      ) : (
        <img
          src={avatarSrc || "https://placehold.co/150x150/000/fff?text=User"}
          alt={participantName}
          className="absolute inset-0 w-full font-semibold h-full object-cover filter brightness-75"
        />
      )}
      <div className="absolute inset-0 flex flex-col justify-between md:p-4 p-2">
        {isScreenSharing ? (
          <div className="flex items-center p-2 bg-blue-50 rounded-full w-fit">
            <>
              <Monitor className="md:h-8 md:w-8 w-5 mr-2 text-black" />
              <span className="text-black opacity- text-sm font-medium">
                {participantName}
              </span>
            </>
          </div>
        ) : (
          // <Avatar className="h-8 w-8  mr-2 bg-[#f9c700]">
          //   <AvatarImage src={avatarSrc} alt={participantName} />
          //   <AvatarFallback className="font-semibold">{participantName.charAt(0)}</AvatarFallback>
          // </Avatar>
          <></>
        )}

        <div className="absolute md:top-4 top-2 right-4 flex space-x-2 ">
          {isRecording && (
            <div className="flex items-center bg-red-100 text-red-600 px-3 py-2 cursor-pointer rounded-full text-sm font-medium">
              <Disc className="h-4 w-4 mr-1 text-red-600 animate-pulse" />{" "}
              Recording
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParticipantDisplay;
